import { z } from 'src/lib'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { FirmaPutFields } from '../types/firma'
import { getEndpointBySistema } from './httpSistema'

const schema = z.object({
    [FirmaPutFields.CodFirmaResultado]: z.number(),
    [FirmaPutFields.CodUsuarioFirma]: z.number(),
    [FirmaPutFields.FirmaUsuario]: z.string(),
    [FirmaPutFields.MailUsuario]: z.string().email().optional(), // TODO: a chequear
    [FirmaPutFields.Observaciones]: z.string().optional() // TODO: mejorar validaciones (max length, etc)
})

export type Firma_Update = z.infer<typeof schema>

export const putFirma = (idOperacion: number, codSistema: number, idFirma: number, firma: Firma_Update) => {
    const endpoint = `${getEndpointBySistema(codSistema)}/${idOperacion}/firmas/${idFirma}`

    const parsed = schema.safeParse(firma)

    if (!parsed.success) {
        return Promise.reject('Error de validación.')
    }

    return HttpAxiosRequest.put(endpoint, parsed.data)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(error => {
            return Promise.reject(error)
        })
}
